import React, { Fragment, useEffect, useState } from 'react';
import Banner from '../Business/Banner';
import Trial from '../Home/Trial';
import FeatureBusiness from './FeaturesBusiness';
import Footer from '../Footer/Footer';
import Loader from '../../loader/Loader';
import Benefits from '../Home/Benefits';
import { useLocale } from '../../localization/LocaleContext';


function SmallbusinessMain(){
    const { t } = useLocale();

    useEffect(() => {
        document.title = t('meta.smallBusinessTitle')
   }, [t]);

   const[loader, SetLoader] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => {
            SetLoader(true)
        }, 1500)

        return () => clearTimeout(timer)
    }, [])

    if (!loader) {
        return <Loader/>;
    }
    return(
        <Fragment>
                <Banner/>
                <FeatureBusiness/>
                <Benefits/>
                <Trial/>
                <Footer />
        </Fragment>
    )
}

export default SmallbusinessMain;